import React from 'react';
import './Pages.css';
import Header from '../header/Header';
import Footer from "../footer/Footer";

const MapPage = () => {
    return (<div className="page-wrapper">
        <Header/>
        <div className="map-page">
            <p>Η «Διαγνωστική Οδύσσεια» του Σπάνιου Ασθενή, αλλά και η έλλειψη πληροφόρησης και διασύνδεσης είναι τα
                βασικότερα προβλήματα που αντιμετωπίζει η Σπάνια Κοινότητα.</p>
            <p>Ο μικρός αριθμός των πασχόντων, η περιορισμένη εξειδικευμένη γνώση, αλλά και η διάσπαρτη πληροφορία
                δυσκολεύουν την εξεύρεση εξειδικευμένου Ιατρικού Προσωπικού για τη διάγνωση και τη φροντίδα,
                Οργανώσεων Ασθενών, όπως και άλλων Υπηρεσιών Υποστήριξης στις οποίες θα μπορούσαν οι Σπάνιοι
                Ασθενείς να αποταθούν.</p>
            <p>Την ίδια στιγμή, παρόμοιες προκλήσεις αντιμετωπίζει και το ιατρικό προσωπικό, καθώς δυσκολεύεται να
                βρει αξιόπιστη και ενημερωμένη πληροφορία για τις Σπάνιες Παθήσεις, για τις άλλες αναγκαίες ιατρικές
                ειδικότητες και τα εξειδικευμένα Κέντρα όπου μπορεί να τους παραπέμψει, όπως και για τις Οργανώσεις
                Ασθενών με τις οποίες μπορεί να τους διασυνδέσει. Μία πρόκληση που μεγεθύνεται ανάλογα με τον τόπο
                κατοικίας του ασθενή και τη σπανιότητα της ασθένειάς του.</p>
            <p>Ο Ελληνικός Χάρτης Σπανίων Παθήσεων (Rare Diseases Greece Map) έρχεται να δώσει λύση σε Ασθενείς και
                Επαγγελματίες Υγείας στο ζήτημα της ελλιπούς ενημέρωσης και διασύνδεσης.</p>
            <p>Συγκεκριμένα, αυτή η διαδικτυακή πλατφόρμα στοχεύει στην παροχή εξειδικευμένης και έγκυρης
                πληροφορίας γύρω από τα Σπάνια Νοσήματα, καθώς και στη διασύνδεση των Ασθενών, των Οργανώσεών τους
                και των Κέντρων Εμπειρογνωμοσύνης και Φροντίδας που ασχολούνται με τα Σπάνια Νοσήματα στην
                Ελλάδα.</p>
            <p>Το εργαλείο, με τη μορφή Χάρτη, επιτρέπει στον Χρήστη, αναζητώντας μία Σπάνια Νόσο, να βρει τα
                σχετικά Κέντρα Εμπειρογνωμοσύνης, τις Ειδικές Μονάδες και τα Εξωτερικά Ιατρεία, όπως και τις
                Οργανώσεις Ασθενών ανά την Ελλάδα.</p>
            <p>Αναλυτικότερα, για κάθε Πάθηση, παρουσιάζονται:</p>
            <ul>
                <li>Η ελληνική και αγγλική της Ονομασία, καθώς και τα συνώνυμά τους</li>
                <li>Οι κωδικοί ταυτοποίησής της (ORPHAcode, CD-10, ICD-11)</li>
                <li>Το σχετικό Ευρωπαϊκό Δίκτυο Αναφοράς (ERN)</li>
                <li>Ο αγγλικός ορισμός της, όπως αυτός καταγράφεται από την Orphanet</li>
                <li>Ο σύνδεσμος που παραπέμπει στη σελίδα της Πάθησης στην Orphanet</li>
                <li>Ο σύνδεσμος που παραπέμπει στη σχετική Επιστημονική Βιβλιογραφία στην PubMed</li>
                <li>Ο σύνδεσμος που παραπέμπει στις σχετικές Κλινικές Δοκιμές στην Ευρώπη αλλά και διεθνώς μέσω του
                    Ευρωπαϊκού Clinical Trials Information System EU και του ClinicalTrials.gov.
                </li>
                <li>Τα ειδικά και σχετικά Εθνικά Κέντρα Εμπειρογνωμοσύνης</li>
                <li>Οι σχετικές Μονάδες και τα Ιατρεία</li>
                <li>Οι σχετικές Οργανώσεις Ασθενών</li>
            </ul>
            <p>Σκοπός του εργαλείου είναι να παρέχει πρόσβαση σε δομημένες, ενοποιημένες και αξιόπιστες πληροφορίες
                για τις Σπάνιες Παθήσεις σε Ασθενείς, Επαγγελματίες Υγείας, Κέντρα Παρακολούθησης και Οργανώσεις
                Ασθενών, προκειμένου:</p>
            <ul>
                <li>να χαρτογραφηθεί η Σπάνια Κοινότητα στην Ελλάδα, περιορίζοντας όχι μόνο τη γεωγραφική απομόνωση
                    των ασθενών, αλλά και τη διαγνωστική τους Οδύσσεια.
                </li>
                <li>να επιταχυνθούν οι χρόνοι και οι διαδικασίες διάγνωσης και πρόσβασης σε ολιστική φροντίδα,
                    βελτιώνοντας έτσι την ποιότητα ζωής των πασχόντων.
                </li>
                <li>να διασυνδεθούν οι Ασθενείς με τις Οργανώσεις τους, τα Κέντρα Εμπειρογνωμοσύνης και Φροντίδας,
                    και με τους εξειδικευμένους Επαγγελματίες Υγείας.
                </li>
                <li>να χαρτογραφηθεί το ταξίδι των Ασθενών στην υγειονομική περίθαλψη εντός του Ε.Σ.Υ..</li>
                <li>Πληκτρολογώντας τον ORPHAcode, ο οποίος είναι μοναδικός για κάθε νόσο.</li>
                <li>Πληκτρολογώντας τον ICD-10, ο οποίος όμως δεν είναι ειδικός της νόσου, και άρα μπορεί να αφορά
                    περισσότερες από μία ασθένειες.
                </li>
                <li>να ενδυναμωθεί η Κοινότητα μέσω μιας πλατφόρμας που προωθεί την ανταλλαγή γνώσεων και τη σωστή
                    διαχείριση των διαφορετικών παθήσεων, συμβάλλοντας ταυτόχρονα στον εντοπισμό άγνωστων ή
                    μικρότερων Οργανώσεων Ασθενών, καθώς και εξειδικευμένων Επαγγελματιών Υγείας σε διάφορες
                    γεωγραφικές περιοχές.
                </li>
                <li>να ενισχυθεί η πρόσβαση σε αξιόπιστη πληροφορία και σε εκπαιδευτικές ευκαιρίες για τους
                    Επαγγελματίες Υγείας και τους Ασθενείς, αυξάνοντας τη γνώση για τις Σπάνιες Παθήσεις.
                </li>
                <li>να προωθηθεί η Καινοτομία, με τη δημιουργία νέων ερευνητικών δικτύων, τη διασύνδεσή τους με
                    δίκτυα και πρωτοβουλίες εντός και εκτός Ελλάδος, καθώς και με την αξιοποίηση χρηματοδοτικών
                    εργαλείων και ευκαιριών.
                </li>
            </ul>
            <p>Το Rare Diseases Greece Map αποτελεί μία από τις δράσεις του Ετήσιου Προγράμματος “EMPOWER 2024” της
                Ένωσης Σπανίων Ασθενών Ελλάδος. Κατά τη διάρκεια του συγκεκριμένου προγράμματος, εκδόθηκε ο Οδηγός
                Δικαιωμάτων και Κοινωνικών Παροχών Ατόμων που ζουν με Σπάνια Νοσήματα, ο Οδηγός Πρόσβασης σε
                Θεραπείες και Ορφανά Φάρμακα για Σπάνια Νοσήματα, ενώ πραγματοποιήθηκε και Μελέτη Εκτίμησης
                Ακάλυπτων Αναγκών των Σπάνιων Ασθενών και των Οργανώσεών τους.</p>
            <h2>Οδηγίες Χρήσης</h2>
            <p>Πώς χρησιμοποιείται ο Χάρτης.</p>
            <p>Ο Χρήστης μπορεί να κάνει αναζήτηση μίας νόσου με πολλαπλούς τρόπους:</p>
            <ul>
                <li>Πληκτρολογώντας την ονομασία της νόσου στα Ελληνικά ή στα Αγγλικά.</li>
                <li>Αναζητώντας τη νόσο στη λίστα του χάρτη και κάνοντας κλικ στην ονομασία της.</li>
            </ul>
            <p>Με την επιλογή της νόσου, στον χάρτη, εμφανίζονται με τη μορφή πινέζας (pin) τα σχετιζόμενα Κέντρα
                Εμπειρογνωμοσύνης (pin), οι Ειδικές Μονάδες και τα Ειδικά Ιατρεία (pin), καθώς και οι Οργανώσεις
                Ασθενών (pin 1, Μέλη της Ε.Σ.Α.Ε / pin 2 Μη μέλη της Ε.Σ.Α.Ε.).</p>
            <p>Κάνοντας κλικ πάνω στην κάθε πινέζα, εμφανίζονται επιπλέον πληροφορίες, όπως η διεύθυνση, το τηλέφωνο
                επικοινωνίας, η ιστοσελίδα, το ΦΕΚ αναγνώρισης του Κέντρου Εμπειρογνωμοσύνης Σπάνιων και Πολύπλοκων
                Νοσημάτων, κ.λπ..</p>
            <p>Στο πλαίσιο με τις Πληροφορίες για τη νόσο, περιλαμβάνονται:</p>
            <ul>
                <li>Ελληνικό Όνομα & Συνώνυμα</li>
                <li>Αγγλική Ονομασία & Συνώνυμα</li>
                <li>ORPHAcode</li>
                <li>ICD-10</li>
                <li>ICD-11</li>
                <li>Ευρωπαϊκά Δίκτυα Αναφοράς - ERN (European Reference Networks)</li>
                <li>Λίστα με Κλινικές Δοκιμές που συγκεντρώνονται στο EU Clinical Trials Register</li>
                <li>Λίστα με Ειδικά & Σχετικά Κέντρα Εμπειρογνωμοσύνης, Ειδικές Μονάδες/Ιατρεία, και Οργανώσεις
                    Ασθενών
                </li>
            </ul>
        </div>
        <Footer/>
    </div>);
};

export default MapPage;